import { connect } from 'react-redux';
import { compose } from 'redux';
import { quickSubPage } from 'decorators/subPage';
import notePage from 'decorators/notePage';

import {
  findQuickSub,
  updateQuickSub,
  fetchServiceCodes,
  fetchQuickRunningActions,
  fetchQuickPortData,
} from 'actions/quickSubs';
import {
  getIncludedInGroups,
  getIsAdmin,
  getLoggedInUser,
  getSubContracts,
  getQuickSubServiceCodes,
  getQuickSubRunningActions,
  getQuickPortData,
} from 'reducers';
import { fetchQuickSubContract } from 'actions/insuranceContracts';

import ViewSub from './ViewSub';
import QuickSub from 'components/quick/QuickSub';
import QuickSubActions from 'components/SubActions/quick';

const mapStateToProps = (state, { subId }) => ({
  isAdmin: getIsAdmin(state),
  isAdminOrManagerOrBusiness: getIncludedInGroups(state, [
    'ADMIN',
    'MANAGER',
    'BUSINESS',
  ]),
  isReseller: getIncludedInGroups(state, ['RESELLER']),
  contracts: getSubContracts(state, subId, 'quick'),
  subServiceCodes: getQuickSubServiceCodes(state, subId),
  runningActions: getQuickSubRunningActions(state, subId),
  portData: getQuickPortData(state, subId),
  pageUrl: (subId, pageNum) =>
    `/quick/subscription/${subId}/view?page=${pageNum}`,
  Sub: QuickSub,
  loggedInUser: getLoggedInUser(state),
  SubActions: QuickSubActions,
});

const mapDispatchToProps = {
  fetchSubContract: fetchQuickSubContract,
  findSub: findQuickSub,
  updateSub: updateQuickSub,
  fetchServiceCodes: fetchServiceCodes,
  fetchRunningActions: fetchQuickRunningActions,
  fetchPortData: fetchQuickPortData,
};

export default compose(
  quickSubPage,
  notePage,
)(connect(mapStateToProps, mapDispatchToProps)(ViewSub));
